(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gr-brand-directory')) {
    customElements.define('gr-brand-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const input = this.querySelector('input[type="search"]');
        const items = Array.from(this.querySelectorAll('[data-brand-name]'));
        const status = this.querySelector('[data-brand-status]');
        const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
        this.querySelector('[data-brand-search]').hidden = false;
        input.addEventListener('input', () => {
          const query = normalize(input.value);
          let count = 0;
          items.forEach(item => {
            item.hidden = !normalize(item.dataset.brandName).includes(query);
            if (!item.hidden) count += 1;
          });
          status.textContent = status.dataset.countTemplate.replace('__COUNT__', count);
          this.querySelector('[data-brand-empty]').hidden = count !== 0;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-invoice-guide"]) return;
  try {
    
  if (!customElements.get('invoice-size-selector')) {
    customElements.define('invoice-size-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-invoice-size]');
          if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const cards = Array.from(this.querySelectorAll('[data-invoice-product-size]'));
          const size = link.dataset.invoiceSize;
          const matches = cards.filter((card) => !size || card.dataset.invoiceProductSize === size);
          if (!matches.length) return;
          event.preventDefault();
          const shown = new Set(matches.slice(0, Number(this.dataset.limit) || 4));
          cards.forEach((card) => { card.hidden = !shown.has(card); });
          this.querySelectorAll('[data-invoice-size]').forEach((option) => {
            if (option === link) option.setAttribute('aria-current', 'true');
            else option.removeAttribute('aria-current');
          });
          const label = link.dataset.sizeLabel;
          const result = this.querySelector('[data-invoice-result]');
          result.textContent = this.dataset.resultLabel.replace('[size]', label);
          const more = this.querySelector('[data-invoice-more]');
          more.href = link.href;
          more.textContent = size ? this.dataset.filteredLabel.replace('[size]', label) : this.dataset.allLabel;
          result.focus({ preventScroll: true });
          result.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
